import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { setClientSelect, setCompanySelect, setBranchSelect } from "../../../store/app/action";
import { getCivilAccount, resetCivilAccountState } from "../../../store/civilAccount/action";
import { getUom } from "../../../store/uom/action";
import { resetProductVarianState, getProductVarian } from "../../../store/productVarian/action";
import { resetBudgetState, getBudget } from "../../../store/budget/action";
import { resetCivilBudgetMaterialState, getCivilBudgetMaterial as onGetCivilBudgetMaterials, addNewCivilBudgetMaterial as onAddNewCivilBudgetMaterial, updateCivilBudgetMaterial as onUpdateCivilBudgetMaterial, deleteCivilBudgetMaterial as onDeleteCivilBudgetMaterial, getCivilBudgetMaterialLoading } from "../../../store/civilBudgetMaterial/action";
import { resetCivilBudgetDetailState, getCivilBudgetDetail as onGetCivilBudgetDetails, addNewCivilBudgetDetail as onAddNewCivilBudgetDetail, updateCivilBudgetDetail as onUpdateCivilBudgetDetail, deleteCivilBudgetDetail as onDeleteCivilBudgetDetail, getCivilBudgetDetailLoading } from "../../../store/civilBudgetDetail/action";
import { getCivilBudget as onGetCivilBudgets, addNewCivilBudget as onAddNewCivilBudget, updateCivilBudget as onUpdateCivilBudget, deleteCivilBudget as onDeleteCivilBudget, getCivilBudgetLoading, resetCivilBudgetState } from "../../../store/civilBudget/action";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import ExportDoc from "../../../Components/Common/ExportDoc";
import { useRef } from "react";

const CivilBudget = () => {
  const filerIdRef = useRef({
    branchId: 1,
  });
  const [modal, setModal] = useState(false);
  const [modalMaterial, setModalMaterial] = useState(false);
  const [modalMaterialEdit, setModalMaterialEdit] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const dispatch = useDispatch();

  const {
    clientSelected,
    companySelected,
    branchSelected,
    userData,
    userType,
    userRole,
    uoms,
    loadingUom,
    civilAccounts,
    loadingCivilAccount,
    clients,
    clientLoading,
    productVarians,
    productVarianLoading,
    branches,
    branchLoading,
    civilBudgets,
    isCivilBudgetCreated,
    isCivilBudgetSuccess,
    loading,
    error,
    civilBudgetDetails,
    civilBudgetDetailLoading,
    isCivilBudgetDetailCreated,
    isCivilBudgetDetailSuccess,
    civilBudgetMaterials,
    civilBudgetMaterialLoading,
    isCivilBudgetMaterialCreated,
    isCivilBudgetMaterialSuccess,
    budgets,
    budgetLoading,
    companies,
    companyLoading,
  } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    civilBudgets: state.CivilBudget.civilBudgets,
    isCivilBudgetCreated: state.CivilBudget.isCivilBudgetCreated,
    isCivilBudgetSuccess: state.CivilBudget.isCivilBudgetSuccess,
    loading: state.CivilBudget.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    error: state.CivilBudget.error,
    civilBudgetDetails: state.CivilBudgetDetail.civilBudgetDetails,
    civilBudgetDetailLoading: state.CivilBudgetDetail.loading,
    isCivilBudgetDetailCreated: state.CivilBudgetDetail.isCivilBudgetDetailCreated,
    isCivilBudgetDetailSuccess: state.CivilBudgetDetail.isCivilBudgetDetailSuccess,
    civilBudgetMaterials: state.CivilBudgetMaterial.civilBudgetMaterials,
    civilBudgetMaterialLoading: state.CivilBudgetMaterial.loading,
    isCivilBudgetMaterialCreated: state.CivilBudgetMaterial.isCivilBudgetMaterialCreated,
    isCivilBudgetMaterialSuccess: state.CivilBudgetMaterial.isCivilBudgetMaterialSuccess,
    civilAccounts: state.CivilAccount.civilAccounts,
    loadingCivilAccount: state.CivilAccount.loading,
    productVarians: state.ProductVarian.productVarians,
    productVarianLoading: state.ProductVarian.loading,
    budgets: state.Budget.budgets,
    budgetLoading: state.Budget.loading,
    uoms: state.Uom.uoms,
    loadingUom: state.Uom.loading,
  }));

  const [isSearch, setIsSearch] = useState(false);
  const [civilBudgetList, setCivilBudgetList] = useState([]);
  const [civilBudget, setCivilBudget] = useState([]);
  const [componentDetailAddedId, setComponentDetailAddedId] = useState(0);
  const [componentMaterialAddedId, setComponentMaterialAddedId] = useState(0);
  const [info, setInfo] = useState(null);
  const [civilBudgetDetailId, setCivilBudgetDetailId] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [budgetList, setBudgetList] = useState([]);
  const [civilBudgetDetail, setCivilBudgetDetail] = useState([]);
  const [civilBudgetMaterial, setCivilBudgetMaterial] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [approveModal, setApproveModal] = useState(false);
  const [civilAccountList, setCivilAccountList] = useState([]);
  const [uomList, setUomList] = useState([]);
  const [dataFormDetail, setDataFormDetail] = useState([]);
  const [materialList, setMaterialList] = useState([]);
  const [searchBranch, setSearchBranch] = useState("");
  const [materialData, setMaterialData] = useState(null);
  const [civilAccountId, setCivilAccountId] = useState(null);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const typeSelectData = [
    {
      options: [
        { label: "INFRASTRUKTUR", value: "INFRASTRUKTUR" },
        { label: "BANGUNAN", value: "BANGUNAN" },
        { label: "UPAH", value: "UPAH" },
        { label: "PROGRESS BANGUNAN", value: "PROGRESS BANGUNAN" },
        { label: "PEKERJAAN TAMBAH 1", value: "PEKERJAAN TAMBAH 1" },
        { label: "PEKERJAAN TAMBAH 2", value: "PEKERJAAN TAMBAH 2" },
        { label: "PEKERJAAN TAMBAH 3", value: "PEKERJAAN TAMBAH 3" },
        { label: "PEKERJAAN TAMBAH 4", value: "PEKERJAAN TAMBAH 4" },
        { label: "PEKERJAAN TAMBAH 5", value: "PEKERJAAN TAMBAH 5" },
        { label: "PEKERJAAN TAMBAH 6", value: "PEKERJAAN TAMBAH 6" },
        { label: "PEKERJAAN TAMBAH 7", value: "PEKERJAAN TAMBAH 7" },
        { label: "PEKERJAAN TAMBAH 8", value: "PEKERJAAN TAMBAH 8" },
        { label: "LISTRIK JARINGAN", value: "LISTRIK JARINGAN" },
      ],
    },
  ];

  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isEditDetail, setIsEditDetail] = useState(false);
  const [isEditMaterial, setIsEditMaterial] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalDetail, setDeleteModalDetail] = useState(false);
  const [deleteModalMaterial, setDeleteModalMaterial] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [companyName, setCompanyName] = useState({});
  const [printDoc, setPrintDoc] = useState([]);

  const onClickDelete = (civilBudget) => {
    setCivilBudget(civilBudget);
    setDeleteModal(true);
  };

  const handleDeleteCivilBudget = () => {
    if (civilBudget) {
      dispatch(onDeleteCivilBudget(civilBudget));
      setDeleteModal(false);
    }
  };

  const handleDeleteCivilBudgetDetail = () => {
    if (civilBudgetDetail) {
      setComponentDetailAddedId(civilBudgetDetail.componentId);
      dispatch(onDeleteCivilBudgetDetail(civilBudgetDetail));
      setDeleteModalDetail(false);
    }
  };

  const handleDeleteCivilBudgetMaterial = () => {
    if (civilBudgetDetail) {
      setComponentMaterialAddedId(civilBudgetMaterial.componentId);
      dispatch(onDeleteCivilBudgetMaterial(civilBudgetMaterial));
      setDeleteModalMaterial(false);
    }
  };

  const onClickApprove = (employee) => {
    setCivilBudget(employee);
    setApproveModal(true);
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredCivilBudgets = civilBudgets;
      if (type !== "all") {
        filteredCivilBudgets = civilBudgets.filter((civilBudget) => civilBudget.cvl_status.name === type);
      }
      setCivilBudgetList(filteredCivilBudgets);
    }
  };

  useEffect(() => {
    if (branchSelected && companySelected) {
      setSearchValue("");
      handleGetCivil(companySelected?.value ?? "", branchSelected?.value ?? "");
    }
  }, [branchSelected, companySelected]);

  useEffect(() => {
    if (info !== null) {
      dispatch(getCivilAccount({ branchId: info.branchId, status: 2 }));
    }
  }, [info]);

  const handleGetCivil = (id, branchId) => {
    dispatch(resetCivilBudgetState());
    dispatch(onGetCivilBudgets({ companyId: id, branchId: branchId }));
    dispatch(getCivilAccount({ companyId: id, branchId: branchId, status: 2 }));
    dispatch(getUom());
    handleGetBudget(id, branchId);
    handleGetProductVariant(id);
  };

  const handleGetProductVariant = (companyId) => {
    dispatch(resetProductVarianState());
    dispatch(getProductVarian({ companyId: companyId, type: "referral" }));
  };

  const handleGetBudget = (companyId, branchId) => {
    dispatch(resetBudgetState());
    dispatch(getBudget({ companyId: companyId, status: 2, branchId: branchId, simple: true }));
  };

  useEffect(() => {
    if (!isEmpty(civilBudgets)) {
      setIsEdit(false);
      let filteredCivilBudgets = civilBudgets;
      if (activeTypeTab !== "all") {
        filteredCivilBudgets = civilBudgets.filter((civilBudget) => civilBudget.cvl_status.name === activeTypeTab);
      }
      setCivilBudgetList(filteredCivilBudgets);
      let current = 0;
      if (componentDetailAddedId !== 0) {
        civilBudgets.forEach((obj, i) => {
          if (obj.id === componentDetailAddedId) current = i;
        });
      }

      if (componentMaterialAddedId !== 0) {
        civilBudgets.forEach((obj, i) => {
          if (obj.id === componentMaterialAddedId) {
            current = i;
            const findMaterial = obj.cvl_detail.find((item) => item.civilAccountId === civilAccountId);
            if (findMaterial) setCivilBudgetMaterial(findMaterial.cvld_material);
          }
        });
      }
      setInfo(civilBudgets[current]);
    }
    else {
      setCivilBudgetList([]);
    }
  }, [civilBudgets, componentDetailAddedId]);

  useEffect(() => {
    if (isCivilBudgetDetailCreated) {
      dispatch(resetCivilBudgetDetailState());
      dispatch(resetCivilBudgetState());
      dispatch(onGetCivilBudgets({ companyId: companySelected.value, branchId: branchSelected.value }));
    }
  }, [dispatch, isCivilBudgetDetailCreated]);

  useEffect(() => {
    if (isCivilBudgetMaterialCreated) {
      dispatch(resetCivilBudgetState());
      dispatch(onGetCivilBudgets({ companyId: companySelected.value, branchId: branchSelected.value }));
    }
  }, [dispatch, isCivilBudgetMaterialCreated]);

  useEffect(() => {
      if (!isEmpty(budgets)) {
        var data = [];
        var opt = [{ label: "NON CASHFLOW", value: "" }];
        budgets.forEach((item, key) => {
          const name = item.type + " - " + item.name + ", " + item?.budget_branch?.branch_code;
          const id = item.id;
          var obj = { label: name, value: id };
          opt.push(obj);
        });
        var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })).reverse() };
        data.push(option);
        setBudgetList(data);
      } else {
        setBudgetList([]);
      }
    }, [budgets]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (branches || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id, companyId: item.companyId };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (branches.length > 0) {
      setBranchList(data);
    }
  }, [branches]);

  useEffect(() => {
    var data = [];
    var list = [];
    var opt = [];
    let dataDetails = [];
    if (info && info.type) {
      civilAccounts.forEach((item, key) => {
        if (item.cvl_account_category.type === info.type) {
          const name = item.name;
          const id = item.id;
          var obj = { label: name, value: id };
          opt.push(obj);

          let samount = item.amount ?? 0;
          let detail = info.cvl_detail.find((x) => x.civilAccountId === item.id);
          if (detail) {
            item.civilBudgetDetailId = detail.id;
            item.quantity = parseFloat(detail.quantity ?? 0);
            item.amount = parseFloat(detail.amount ?? 0);
            item.weight = detail.weight;
            item.description = detail.description;
            item.cvld_material = detail.cvld_material || [];

            samount = detail.cvld_material.length === 0 ? detail.amount : (detail.cvld_material || []).reduce((a, v) => (a = a + parseFloat(v.price) * parseFloat(v.quantity)), 0);
          }
          list.push(item);

          dataDetails.push({
            name: item.name,
            civilAccountId: item.id,
            type: item?.cvl_account_category?.type ?? "",
            uomId: item?.uomId ?? 0,
            quantity: item?.quantity ?? 0,
            amount: samount,
            weight: item.weight ?? 0,
            description: item.description ?? "",
            statusId: item.statusId,
          });
        }
      });
      var option = { options: opt };
      data.push(option);
    }
    setCivilAccountList(list.map((el) => ({ ...el, isChecked: false })));
    setDataFormDetail(dataDetails);
  }, [civilAccounts]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "name",
        label: "Item Anggaran",
        isSelected: true,
        data: [],
      },
      {
        id: "quantity",
        label: "Jumlah",
        isSelected: true,
        data: [],
      },
      {
        id: "amount",
        label: "Harga",
        isSelected: true,
        data: [],
      },
      {
        id: "weight",
        label: "Bobot",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
    ];

    if (civilAccountList.length > 0) {
      civilAccountList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              doc.data.push(value ?? "-");
            }
          });
        }
      });
    }

    setPrintDoc(dataDoc);
  }, [civilAccountList]);

  useEffect(() => {
    if (!isEmpty(productVarians)) {
      var materialVarianData = [];
      var opt_material = [];
      productVarians.forEach((item, key) => {
        const varian = item.pvar_product ? item.pvar_product : "";
        const id = item.id;
        const barcode = item.barcode;
        const sku = item.sku;
        const price = item.price;
        const brandId = item.brandId;
        const productId = item.productId;
        let option_name = "";
        item.pvar_options &&
          item.pvar_options.forEach((i, k) => {
            option_name += i.name + "/";
          });
        if (item.typeId === 2) {
          opt_material.push({ label: varian.name, name: varian.name + " " + option_name.slice(0, -1), barcode: barcode, sku: sku, value: id, price: price, brandId: brandId, productId: productId });
        }
      });

      var option_material = { options: opt_material };
      materialVarianData.push(option_material);
      setMaterialList(materialVarianData);
    }
  }, [productVarians]);

  useEffect(() => {
    var data = [];
    var opt = [];
    uoms.forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (uoms.length > 0) {
      setUomList(data);
    }
  }, [uoms]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setCivilBudget(null);
    } else {
      setModal(true);
    }
  }, [modal, dispatch]);

  const toggleMaterial = useCallback(() => {
    if (modalMaterial) {
      validationMaterial.resetForm({});
      setCivilAccountId(null);
      setModalMaterial(false);
    } else {
      setModalMaterial(true);
    }
  }, [modalMaterial, dispatch]);

  const toggleMaterialEdit = useCallback(() => {
    if (modalMaterialEdit) {
      setMaterialData(null);
      setModalMaterialEdit(false);
    } else {
      setModalMaterialEdit(true);
    }
  }, [modalMaterialEdit]);

  const [filterDate, setFilterDate] = useState(null);

  const handleCivilBudgetClick = useCallback(
    (arg) => {
      const data = arg;
      setCivilBudget({
        id: data.id,
        name: data.name,
        approvedat: data.approvedat,
        unit: data.unit,
        size: data.size,
        progress: data.progress,

        budget: data.cvl_budget && { label: data.cvl_budget.name, value: data.cvl_budget.id },
        type: {
          label: data.type,
          value: data.type,
        },
        client: data.cvl_client && {
          label: data.cvl_client ? data.cvl_client.name : "",
          value: data.cvl_client ? data.cvl_client.id : "",
        },
        company: data.cvl_company && {
          label: data.cvl_company ? data.cvl_company.name : "",
          value: data.cvl_company ? data.cvl_company.id : "",
        },
        branch: data.cvl_branch && {
          label: data.cvl_branch ? data.cvl_branch.name : "",
          value: data.cvl_branch ? data.cvl_branch.id : "",
        },
        status: {
          label: data.cvl_status.name,
          value: data.cvl_status.id,
        },
      });

      setIsEdit(true);
      toggle();
    },
    [toggle, userType]
  );

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: "",
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className="btn-sm"
                    onClick={() => {
                      setInfo(data);
                    }}
                  >
                    <i className="ri-eye-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateCivilBudget") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handleCivilBudgetClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteCivilBudget") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
              {data.statusId === 1 && (
                <button
                  className={userType === "admin" || userType === "client" || userType === "company" ? "btn-label btn btn-sm btn-soft-success fs-12 ms-1" : userRole && userRole.split(",").indexOf("approveCivilBudget") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 ms-1" : "btn-label btn btn-sm btn-soft-success fs-12 ms-1 d-none"}
                  onClick={() => {
                    data.statusId = 2;
                    setInfo(data);
                    onClickApprove();
                  }}
                >
                  <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i> Approve
                </button>
              )}
            </div>
          );
        },
      },
      {
        id: "Nama",
        Header: "Nama",
        accessor: "name",
        filterable: true,
      },
      {
        id: "Branch",
        Header: "Nama",
        accessor: "cvl_branch.name",
        filterable: true,
      },
      {
        Header: "Anggaran",
        accessor: "type",
        filterable: true,
        Cell: (cell) => {
          const data = cell.row.original;
          let type;
          let typeName = data.type;
          let stat;
          let statName = data.statusId;
          switch (typeName) {
            case "BANGUNAN":
              type = <span className="badge text-uppercase badge-soft-info">{typeName}</span>;
              break;
            case "INFRASTRUKTUR":
              type = <span className="badge text-uppercase badge-soft-success">{typeName}</span>;
              break;
            case "UPAH":
              type = <span className="badge text-uppercase badge-soft-warning">{typeName}</span>;
              break;
            default:
              type = <span className="badge text-uppercase badge-soft-primary">{typeName}</span>;
              break;
          }

          switch (statName) {
            case 1:
              stat = <span className="badge text-uppercase badge-soft-warning">DRAFT</span>;
              break;
            case 2:
              stat = <span className="badge text-uppercase badge-soft-info">ACTIVE</span>;
              break;
            default:
              stat = <span className="badge text-uppercase badge-soft-warning">DRAFT</span>;
              break;
          }

          return (
            <div
              className="cursor-pointer"
              onClick={() => {
                setInfo(data);
              }}
            >
              <div className="fw-semibold mb-0">{data.name}</div>
              <div className="mb-2">{data.cvl_branch && data.cvl_branch.name}</div>
              <div className="hstack gap-2">
                {type} {stat}
              </div>
            </div>
          );
        },
      },
    ],
    [handleCivilBudgetClick]
  );

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: civilBudgetList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,
        hiddenColumns: ["Nama", "Branch"],
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const [isCheckAllSecond, setIsCheckAllSecond] = useState(false);
  const rowsRef = useRef([]);
  const checkedAllSecond = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = civilAccountList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setCivilAccountList(updated);
    setIsCheckAllSecond(allChecked);
  };

  const columnsSecond = useMemo(
    () =>
      [
        {
          id: "#",
          Header: <input type="checkbox" id="checkBoxAllSecond" className="form-check-input" checked={isCheckAllSecond} onChange={checkedAllSecond} />,
          accessor: "name",
          Cell: (cellProps) => {
            const data = cellProps.row.original;
            return (
              <div className="hstack gap-2 mt-4 mt-sm-0">
                <input
                  type="checkbox"
                  className="dataCheckboxSecond me-1 form-check-input"
                  checked={data.isChecked}
                  onChange={() => {
                    const updatedData = civilAccountList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                    setCivilAccountList(updatedData);
                  }}
                />
                <div className="text-wrap name fs-12">
                  {data.civilBudgetDetailId && (
                    <Button
                      color="soft-info"
                      className="btn-sm me-2"
                      onClick={() => {
                        setCivilAccountId(data.id);
                        setCivilBudgetMaterial(data.cvld_material);
                        setCivilBudgetDetailId(data.civilBudgetDetailId);
                        toggleMaterial();
                      }}
                    >
                      <i className="ri-add-line fs-12"></i> Material
                    </Button>
                  )}
                  {data.name !== null ? data.name : "-"}
                </div>
              </div>
            );
          },
        },
        {
          Header: "Harga",
          accessor: "amount",
          filterable: false,
          Cell: (cell) => {
            const amount = cell.row.original.cvld_material && cell.row.original.cvld_material.length === 0 ? dataFormDetail[cell.row.index]?.amount : (cell.row.original.cvld_material || []).reduce((a, v) => (a = a + parseFloat(v.price) * parseFloat(v.quantity)), 0);
            return (
              <Input
                name="amount"
                id="amount-field"
                className="form-control"
                placeholder="Enter Harga Material"
                type="number"
                style={{ width: "160px" }}
                defaultValue={parseFloat(amount)}
                onFocus={(e) => e.target.select()}
                onChange={(e) => {
                  let value = e.target.value;
                  if (value === "") {
                    value = 0;
                  }
                  dataFormDetail[cell.row.index].amount = value;
                }}
              />
            );
          },
        },
        {
          Header: "Jumlah",
          accessor: "quantity",
          filterable: false,
          Cell: (cell) => {
            return cell.row.original.cvld_material && cell.row.original.cvld_material.length === 0 ? (
              <Input
                name="quantity"
                id="quantity-field"
                className="form-control"
                placeholder="Enter Jumlah"
                type="number"
                style={{ width: "95px" }}
                defaultValue={dataFormDetail[cell.row.index]?.quantity ?? 0}
                onFocus={(e) => e.target.select()}
                onChange={(e) => {
                  let value = e.target.value;
                  if (value === "") {
                    value = "0";
                  }
                  dataFormDetail[cell.row.index].quantity = e.target.value;
                }}
              />
            ) : (
              <div className="text-center">Ls</div>
            );
          },
        },
        {
          Header: "Bobot",
          accessor: "weight",
          filterable: false,
          Cell: (cell) => {
            return (
              <Input
                name="weight"
                id="weight-field"
                className="form-control"
                placeholder="Enter Bobot"
                type="number"
                style={{ width: "95px" }}
                defaultValue={dataFormDetail[cell.row.index]?.weight ?? 0}
                onFocus={(e) => e.target.select()}
                onChange={(e) => {
                  let value = e.target.value;
                  if (value === "") {
                    value = "0";
                  }
                  dataFormDetail[cell.row.index].weight = e.target.value;
                }}
              />
            );
          },
        },
        {
          Header: "Keterangan",
          accessor: "description",
          filterable: false,
          Cell: (cell) => {
            return (
              <Input
                name="description"
                id="description-field"
                className="form-control fs-11"
                placeholder=""
                type="text"
                defaultValue={dataFormDetail[cell.row.index]?.description ?? ""}
                onChange={(e) => {
                  dataFormDetail[cell.row.index].description = e.target.value;
                }}
              />
            );
          },
        },
      ].filter(Boolean),
    [civilAccountList, info, dataFormDetail, userType, userRole, toggleMaterial, isCheckAllSecond]
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 600);

  const handleApproveComponent = () => {
    if (info) {
      info.setApprove = true;
      dispatch(onUpdateCivilBudget(info));
      setApproveModal(false);
    }
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      name: (civilBudget && civilBudget.name) ?? "",
      type: (civilBudget && civilBudget.type) ?? "",
      approvedat: (civilBudget && civilBudget.approvedat) ?? "",
      status: (civilBudget && civilBudget.status) ?? "",
      branch: (civilBudget && civilBudget.branch) ?? "",
      company: (civilBudget && civilBudget.company) || companySelected,
      client: (civilBudget && civilBudget.client) || clientSelected,
      budget: (civilBudget && civilBudget.budget) ?? "",
      unit: (civilBudget && civilBudget.unit),
      size: (civilBudget && civilBudget.size),
      progress: (civilBudget && civilBudget.progress),
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Name").nullable(true),
      company: Yup.object().required("Please Enter company").nullable(true),
      type: Yup.object().required("Please Enter Jenis RAB").nullable(true),
      branch: Yup.object().required("Please Enter Proyek / Cabang").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getCivilBudgetLoading());
      if (isEdit) {
        const updateCivilBudget = {
          id: civilBudget ? civilBudget.id : 0,
          name: values.name,
          unit: values.unit,
          size: values.size,
          progress: values.progress,
          type: values.type.value,
          budgetId: values.budget.value,
          statusId: 2,
          branchId: values.branch.value,
          companyId: values.company.value,
          clientId: values.client.value,
        };
        dispatch(onUpdateCivilBudget(updateCivilBudget));
        validation.resetForm();
      } else {
        const newCivilBudget = {
          name: values.name,
          unit: values.unit,
          size: values.size,
          progress: values.progress,
          type: values.type.value,
          budgetId: values.budget.value,
          statusId: 2,
          branchId: values.branch.value,
          companyId: values.company.value,
          clientId: values.client.value,
        };
        dispatch(onAddNewCivilBudget(newCivilBudget));
        validation.resetForm();
      }
      toggle();
    },
  });

  const validationDetail = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      civilBudgetId: (civilBudgetDetail && civilBudgetDetail.civilBudgetId) || (info && info.id),
      company: (civilBudgetDetail && civilBudgetDetail.company) || companySelected,
      client: (civilBudgetDetail && civilBudgetDetail.client) || clientSelected,
    },
    validationSchema: Yup.object({}),
    onSubmit: (values) => {
      dispatch(getCivilBudgetDetailLoading());
      const newCivilBudgetDetail = {
        budget_detail: dataFormDetail,
        civilBudgetId: values.civilBudgetId,
        companyId: values.company.value,
        clientId: values.client.value,
      };
      dispatch(onAddNewCivilBudgetDetail(newCivilBudgetDetail));
      setComponentDetailAddedId(values.civilBudgetId);
    },
  });

  const validationMaterial = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      civilBudgetId: (info && info.civilBudgetId) || (info && info.id),
      product: (info && info.product) ?? "",
      quantity: (info && info.quantity) || 0,
      price: (info && info.price) || 0,
    },
    validationSchema: Yup.object({
      product: Yup.object().required("Silahkan isi Produk").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getCivilBudgetMaterialLoading());
      const data = {
        civilBudgetDetailId: civilBudgetDetailId,
        civilBudgetId: info.id,
        productId: values.product.productId,
        quantity: values.quantity,
        price: values.price,
        companyId: info.companyId,
        clientId: info.clientId,
      };
      setComponentMaterialAddedId(info.id);
      dispatch(onAddNewCivilBudgetMaterial(data));
      validationMaterial.resetForm({});
    },
  });

  const validationMaterialEdit = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      quantity: (materialData && materialData.quantity) || 0,
      price: (materialData && materialData.price) || 0,
    },
    validationSchema: Yup.object({}),
    onSubmit: (values) => {
      dispatch(getCivilBudgetMaterialLoading());
      materialData.quantity = values.quantity;
      materialData.price = values.price;
      setComponentMaterialAddedId(info.id);
      dispatch(onUpdateCivilBudgetMaterial(materialData));
      toggleMaterialEdit();
    },
  });

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteCivilBudgetDetail(element.value));
    });
    checkall.checked = false;
  };

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      branchId: searchBranch.value ?? "",
      companyId: companySelected.value ?? "",
    };

    dispatch(onGetCivilBudgets(param));
  }

  function handleResetFilter() {
    setFilterDate(null);
    setCivilAccountList([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    setGlobalFilterValue("");

    dispatch(onGetCivilBudgets({ companyId: companySelected?.value ?? "", branchId: branchSelected?.value ?? "" }));
  }

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChangeSecond = useAsyncDebounce((value) => {
    const resetChecked = civilAccountList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setCivilAccountList(resetChecked);
    setIsCheckAllSecond(false);
    setGlobalFilterSecond(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => civilAccountList, [civilAccountList]);

  const {
    getTableProps: getTablePropsSecond,
    rows: rowSecond,
    getTableBodyProps: getTableBodyPropsSecond,
    headerGroups: headerGroupsSecond,
    page: pageSecond,
    prepareRow: prepareRowSecond,
    canPreviousPage: canPreviousPageSecond,
    canNextPage: canNextPageSecond,
    pageOptions: pageOptionsSecond,
    gotoPage: gotoPageSecond,
    nextPage: nextPageSecond,
    previousPage: previousPageSecond,
    setPageSize: setPageSizeSecond,
    preGlobalFilteredRows: preGlobalFilteredRowsSecond,
    setGlobalFilter: setGlobalFilterSecond,
    state: { pageIndexSecond, pageSizeSecond },
  } = useTable(
    {
      columns: columnsSecond,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 1000,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rowSecond.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAllSecond(allChecked);
  }, [rowSecond]);

  const countSecond = preGlobalFilteredRowsSecond.length;
  const [searchValueSecond, setSearchValueSecond] = useState([]);

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  document.title = "Rencana Anggaran Biaya | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ApproveModal data={civilBudget && civilBudget.contract_employee ? civilBudget.contract_employee.name : ""} show={approveModal} onApproveClick={handleApproveComponent} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteCivilBudget} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal show={deleteModalDetail} onDeleteClick={handleDeleteCivilBudgetDetail} onCloseClick={() => setDeleteModalDetail(false)} />
      <DeleteModal show={deleteModalMaterial} onDeleteClick={handleDeleteCivilBudgetMaterial} onCloseClick={() => setDeleteModalMaterial(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Teknik" pageTitle="Rencana Anggaran Biaya" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createCivilBudget") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                toggle();
              }}><i className="ri-booklet-line me-1 align-bottom fs-14"></i> Tambah
            </button>
          </div>
        </BreadCrumb>
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody className="pt-0 pb-0">
                <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                      onClick={() => {
                        toggleTab("1", "all");
                      }}
                      href="#">
                      <i className="ri-booklet-line me-1 align-bottom fs-14"></i> ALL
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                      onClick={() => {
                        toggleTab("2", "DRAFT");
                      }}
                      href="#">
                      <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                      onClick={() => {
                        toggleTab("3", "ACTIVE");
                      }}
                      href="#">
                      <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                      onClick={() => {
                        toggleTab("4", "INACTIVE");
                      }}
                      href="#">
                      <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                    </NavLink>
                  </NavItem>
                </Nav>
                <Row className="">
                  <CardBody className="pb-1">
                    <form>
                      <Row>
                        <Col sm={2}>
                          <div className="me-2 mb-2 col-12">
                            <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                              {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                  {pageSize}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={8}>
                          <div className="search-box me-2 mb-2 d-inline-block col-12">
                            <input
                              onChange={(e) => {
                                setSearchValue(e.target.value);
                                onChange(e.target.value);
                                gotoPage(0);
                              }}
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              placeholder={`${count} Cari...`}
                              value={searchValue ?? ""}
                            />
                            <i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={2}>
                          <div className="hstack gap-2">
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleFilter();
                              }}
                            >
                              <i className="ri-search-line align-bottom fs-16"></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleResetFilter();
                              }}
                            >
                              <i className="mdi mdi-restore align-bottom fs-18"></i>
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </form>
                  </CardBody>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col sm={3}>
            <Card>
              <CardBody className="pt-3">
                <div>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-info">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>

                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <div className="text-end pe-2">
                    Halaman {pageIndex + 1} dari {pageOptions.length}
                  </div>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Rencana Anggaran Biaya" : "Tambah Rencana Anggaran Biaya"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp;
                              {clientLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                setCompanyList([]);
                                dispatch(setClientSelect(e));
                                validation.setFieldValue("client", e);
                              }}
                              options={clientList}
                            ></Select>
                            {validation.touched.client && validation.errors.client && (
                              <small className="text-danger" type="invalid">
                                {validation.errors.client}
                              </small>
                            )}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp;
                              {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                dispatch(setCompanySelect(e));
                                setBranchList([]);
                                validation.resetForm();
                                validation.setFieldValue("company", e);
                              }}
                              options={companyList}
                            ></Select>
                            {validation.touched.company && validation.errors.company && (
                              <small className="text-danger" type="invalid">
                                {validation.errors.company}
                              </small>
                            )}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="branch-field" className="form-label">
                              Proyek / Cabang&nbsp;
                              {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="branch"
                              value={validation.values.branch}
                              placeholder="Pilih Proyek / Cabang"
                              onChange={(e) => {
                                validation.resetForm();
                                validation.setFieldValue("branch", e);
                              }}
                              options={branchList}
                            ></Select>
                            {validation.touched.branch && validation.errors.branch && (
                              <small className="text-danger" type="invalid">
                                {validation.errors.branch}
                              </small>
                            )}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="type-field" className="form-label">
                              Jenis RAB
                            </Label>
                            <Select
                              name="type"
                              value={validation.values.type}
                              placeholder="Pilih Jenis RAB"
                              onChange={(e) => {
                                validation.setFieldValue("type", e);
                              }}
                              options={typeSelectData}
                            ></Select>
                            {validation.touched.type && validation.errors.type && (
                              <small className="text-danger" type="invalid">
                                {validation.errors.type}
                              </small>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              Nama RAB
                            </Label>
                            <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name} invalid={validation.touched.name && validation.errors.name ? true : false} />
                            {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                          </div>
                          <div className="mb-3 d-none">
                            <Label htmlFor="status-field" className="form-label">
                              Status
                            </Label>
                            <Select
                              name="status"
                              value={validation.values.status}
                              placeholder="Pilih Status"
                              onChange={(e) => {
                                validation.setFieldValue("status", e);
                              }}
                              options={statusActiveData}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="status-field" className="form-label">
                              Cashflow
                            </Label>
                            <Select
                              name="budget"
                              value={validation.values.budget}
                              placeholder="Pilih Cashflow"
                              onChange={(e) => {
                                validation.setFieldValue("budget", e);
                              }}
                              options={budgetList}
                            ></Select>
                            {validation.touched.budget && validation.errors.budget && (
                              <small className="text-danger" type="invalid">
                                {validation.errors.budget}
                              </small>
                            )}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="status-field" className="form-label">
                              Jumlah Unit Dibangun (Jika Bangunan default 1)
                            </Label>
                            <Input
                              name="unit"
                              placeholder="Jumlah Unit"
                              type="number"
                              className="form-control"
                              onFocus={(e) => e.target.select()}
                              value={parseFloat(validation.values.unit || 1)}
                              onChange={(e) => {
                                validation.setFieldValue("unit", parseFloat(e.target.value || 1));
                              }}
                              onBlur={validation.handleBlur}
                            />
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="status-field" className="form-label">
                              Luas Tanah & Progress Infrastruktur (Jika Infrastruktur)
                            </Label>
                            <div className="row">
                              <div className="col-lg-7">
                                <Input
                                name="size"
                                placeholder="Luas Ha"
                                type="number"
                                className="form-control"
                                onFocus={(e) => e.target.select()}
                                value={parseFloat(validation.values.size)}
                                onChange={(e) => {
                                  validation.setFieldValue("size", parseFloat(e.target.value));
                                }}
                                onBlur={validation.handleBlur}
                              />
                              </div>
                              <div className="col-lg-5">
                                <Input
                                name="progress"
                                placeholder="progress"
                                type="number"
                                className="form-control"
                                onFocus={(e) => e.target.select()}
                                value={parseFloat(validation.values.progress)}
                                onChange={(e) => {
                                  validation.setFieldValue("progress", parseFloat(e.target.value));
                                }}
                                onBlur={validation.handleBlur}
                              />
                              </div>
                              
                            </div>

                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEdit ? "Update" : "Simpan"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModal" isOpen={modalMaterial} centered size="xl">
                  <ModalHeader
                    className="bg-light p-3"
                    toggle={() => {
                      toggleMaterial();
                    }}
                  >
                    Detail Material
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationMaterial.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div>
                        <div className={userType === "admin" || userType === "client" || userType === "company" ? "row" : userRole && userRole.split(",").indexOf("createCivilBudget") !== -1 ? "row" : "d-none"}>
                          <div className="mb-3 col-lg-5">
                            <Label htmlFor="type-field" className="form-label">
                              Produk Material
                            </Label>
                            <Select
                              name="product"
                              value={validationMaterial.values.product}
                              placeholder="Pilih Material"
                              onChange={(e) => {
                                validationMaterial.setFieldValue("product", e);
                              }}
                              options={materialList}
                            ></Select>
                            {validationMaterial.touched.product && validationMaterial.errors.product && (
                              <small className="text-danger" type="invalid">
                                {validationMaterial.errors.product}
                              </small>
                            )}
                          </div>
                          <div className="mb-3 col-lg-2">
                            <Label htmlFor="quantity-field" className="form-label">
                              Volume
                            </Label>
                            <Input name="quantity" id="quantity-field" className="form-control" placeholder="Isi Harga" type="number" onChange={validationMaterial.handleChange} onBlur={validationMaterial.handleBlur} onFocus={(e) => e.target.select()} value={validationMaterial.values.quantity} invalid={validationMaterial.touched.quantity && validationMaterial.errors.quantity ? true : false} />
                            {validationMaterial.touched.quantity && validationMaterial.errors.quantity ? <FormFeedback type="invalid">{validationMaterial.errors.quantity}</FormFeedback> : null}
                          </div>
                          <div className="mb-3 col-lg-3">
                            <Label htmlFor="price-field" className="form-label">
                              Harga
                            </Label>
                            <Input name="price" id="price-field" className="form-control" placeholder="Isi Harga" type="number" onChange={validationMaterial.handleChange} onBlur={validationMaterial.handleBlur} onFocus={(e) => e.target.select()} value={validationMaterial.values.price} invalid={validationMaterial.touched.price && validationMaterial.errors.price ? true : false} />
                            {validationMaterial.touched.price && validationMaterial.errors.price ? <FormFeedback type="invalid">{validationMaterial.errors.price}</FormFeedback> : null}
                          </div>
                          <div className="mb-3 col-lg-2">
                            <Label htmlFor="quantity-field" className="form-label">
                              &nbsp;
                            </Label>
                            <button type="submit" className="btn btn-success form-control">
                              <span className="d-flex align-items-center">
                                <span className="flex-grow-1 me-2">{!!isEdit ? "Update" : "Simpan"}</span>
                                {loading && (
                                  <Spinner size="sm" className="flex-shrink-0" role="status">
                                    Loading...
                                  </Spinner>
                                )}
                              </span>
                            </button>
                          </div>
                        </div>
                        <Table className="table-nowrap mb-0">
                          <thead className="align-middle">
                            <tr className="table-active">
                              <td style={{ width: "20px" }}>#</td>
                              <td>Material</td>
                              <td className="text-center" style={{ width: "170px" }}>
                                Volume
                              </td>
                              <td className="text-center" style={{ width: "170px" }}>
                                Harga
                              </td>
                              <td className="text-center" style={{ width: "170px" }}>
                                Total
                              </td>
                              <td className="text-center" style={{ width: "100px" }}></td>
                            </tr>
                          </thead>
                          <tbody id="newlink">
                            {(civilBudgetMaterial || [])
                              .sort((a, b) => a?.cvlm_material?.name.localeCompare(b?.cvlm_material?.name, undefined, { numeric: true, sensitivity: "base" }))
                              .map((o, i) => {
                                return (
                                  <tr key={i} id={i} className="product">
                                    <td className="product-id">
                                      {i + 1}
                                    </td>
                                    <td className="">
                                      {o.cvlm_material && o.cvlm_material.name}
                                    </td>
                                    <td className="fs-14">
                                      {currencyFormat(o.quantity)}
                                    </td>
                                    <td className="fs-14 fw-semibold">
                                      {currencyFormat(o.price)}
                                    </td>
                                    <td className="fs-14 fw-semibold">
                                      {currencyFormat(parseFloat(o.quantity) * parseFloat(o.price) || 0)}
                                    </td>
                                    <td className="">
                                      <div className={userType === "admin" || userType === "client" || userType === "company" ? "" : userRole && userRole.split(",").indexOf("updateCivilBudget") !== -1 ? "" : "d-none"}>
                                        <ButtonGroup className="me-1 pb-0">
                                          <Button
                                            color="light"
                                            className={"btn-sm"}
                                            onClick={() => {
                                              setMaterialData(o);
                                              toggleMaterialEdit();
                                            }}
                                          >
                                            <i className="ri-edit-2-line fs-15"></i>
                                          </Button>
                                          <Button
                                            color="light"
                                            className={"btn-sm"}
                                            onClick={() => {
                                              dispatch(getCivilBudgetMaterialLoading());
                                              setComponentMaterialAddedId(info.id);
                                              dispatch(onDeleteCivilBudgetMaterial(o));
                                            }}
                                          >
                                            <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                          </Button>
                                        </ButtonGroup>
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}

                            {civilBudgetMaterial.length === 0 && (
                              <tr>
                                <td colSpan="7" className="p-3 text-center fs-14">
                                  Detail Anggaran belum ditambahkan
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            toggleMaterial();
                          }}
                        >
                          Tutup
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

                <Modal id="showModal" isOpen={modalMaterialEdit} centered size="md">
                  <ModalHeader
                    className="bg-light p-3"
                    toggle={() => {
                      toggleMaterialEdit();
                    }}
                  >
                    {"Ubah"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationMaterialEdit.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="row">
                            <div className="mb-3 col-lg-5">
                              <Label htmlFor="quantity-field" className="form-label">
                                Volume
                              </Label>
                              <Input name="quantity" id="quantity-field" className="form-control" placeholder="Isi Harga" type="number" onChange={validationMaterialEdit.handleChange} onBlur={validationMaterialEdit.handleBlur} onFocus={(e) => e.target.select()} value={validationMaterialEdit.values.quantity} invalid={validationMaterialEdit.touched.quantity && validationMaterialEdit.errors.quantity ? true : false} />
                              {validationMaterialEdit.touched.quantity && validationMaterialEdit.errors.quantity ? <FormFeedback type="invalid">{validationMaterialEdit.errors.quantity}</FormFeedback> : null}
                            </div>
                            <div className="mb-3 col-lg-7">
                              <Label htmlFor="price-field" className="form-label">
                                Harga
                              </Label>
                              <Input name="price" id="price-field" className="form-control" placeholder="Isi Harga" type="number" onChange={validationMaterialEdit.handleChange} onBlur={validationMaterialEdit.handleBlur} onFocus={(e) => e.target.select()} value={validationMaterialEdit.values.price} invalid={validationMaterialEdit.touched.price && validationMaterialEdit.errors.price ? true : false} />
                              {validationMaterialEdit.touched.price && validationMaterialEdit.errors.price ? <FormFeedback type="invalid">{validationMaterialEdit.errors.price}</FormFeedback> : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            toggleMaterialEdit();
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Simpan"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
          <Col sm={9}>
            <Card>
              <div className="card-body d-flex align-items-center">
                <h5 className="mb-2 flex-grow-1">
                  {"Detail Anggaran"}
                  {(loading || civilBudgetDetailLoading || civilBudgetMaterialLoading || loadingCivilAccount) && (
                    <>
                      <Spinner color="primary" type="grow" size={"sm"}>
                        Loading...
                      </Spinner>
                      &nbsp;
                      <Spinner color="success" type="grow" size={"sm"}>
                        Loading...
                      </Spinner>
                      &nbsp;
                    </>
                  )}
                </h5>
                <div className="flex-shrink-0">
                  <div style={{ width: "240px" }} className="search-box d-inline-block me-2">
                    <input
                      onChange={(e) => {
                        setSearchValueSecond(e.target.value);
                        onChangeSecond(e.target.value);
                      }}
                      id="search-bar-0"
                      type="text"
                      className="form-control search"
                      placeholder={`${countSecond} Cari...`}
                      value={searchValueSecond ?? ""}
                    />
                    <i className="bx bx-search-alt search-icon"></i>
                  </div>
                  <button
                    type="button"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-info add-btn me-2" : userRole && userRole.split(",").indexOf("createCivilBudget") !== -1 ? "btn btn-info add-btn me-2" : "d-none"}
                    id="create-btn"
                    onClick={() => {
                      validationDetail.handleSubmit();
                    }}
                  >
                    <span className="d-flex align-items-center">
                      SIMPAN ANGGARAN &nbsp;
                      {civilBudgetDetailLoading && (
                        <Spinner size="sm" className="flex-shrink-0" role="status">
                          Loading...
                        </Spinner>
                      )}
                    </span>
                  </button>
                  <ExportDoc data={printDoc} />
                </div>
              </div>
              <div className="card-body ">
                <div className="table-responsive table-card mb-1">
                  <Table hover {...getTablePropsSecond()} className="align-middle table-nowrap">
                    <thead className="table-light">
                      {headerGroupsSecond.map((headerGroup, index) => (
                        <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                          {headerGroup.headers.map((column, index) => (
                            <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                              {column.render("Header")}
                              {generateSortingIndicator(column)}
                              {/* <Filter column={column} /> */}
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>
                    <tbody {...getTableBodyPropsSecond()}>
                      {pageSecond.map((row) => {
                        prepareRowSecond(row);
                        return (
                          <Fragment key={row.getRowProps().key}>
                            <tr>
                              {row.cells.map((cell, index) => {
                                return (
                                  <td {...cell.getCellProps()} key={index}>
                                    {cell.render("Cell")}
                                  </td>
                                );
                              })}
                            </tr>
                          </Fragment>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CivilBudget;
